import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { VersionService } from 'src/app/services/version.service';
import { environment } from 'src/environments/environment';
import { Platform } from '@ionic/angular';
import { LocalDbService } from 'src/app/services/localDb.service';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  standalone: false,
  selector: 'app-version-update',
  templateUrl: './version-update.component.html',
  styleUrls: ['./version-update.component.scss'],
})
export class VersionUpdateComponent implements OnInit {
  oldVersionNumber = VersionService.version;
  isWeb: boolean = false;

  @Input() header: string = 'New Update Available!';
  @Input() description: string = 'A new version of Vanshavali is ready with improvements and bug fixes. Please update to continue.';
  @Input() version: string | number = '';
  @Output() close = new EventEmitter<void>();

  constructor(
    private platform: Platform,
    private localDb: LocalDbService, private auth: AuthService
  ) { }

  ngOnInit() {
    this.isWeb = !this.platform.is('hybrid');
  }

  onClose() {
    this.close.emit();
  }

  async reloadApp() {
    if (this.isWeb) {
      try {
        await this.localDb.localClear();

        localStorage.clear();
        sessionStorage.clear();

        const cookies = document.cookie.split(";");
        for (let i = 0; i < cookies.length; i++) {
          const cookie = cookies[i];
          const eqPos = cookie.indexOf("=");
          const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
          document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
        }

        if ('caches' in window) {
          const cacheKeys = await caches.keys();
          await Promise.all(cacheKeys.map(key => caches.delete(key)));
        }
        this.auth.signOut(false, false, true);
      } catch (e) {
        console.error("Error clearing storage:", e);
      }
    }
    window.location.reload();
  }

  downloadApp() {
    if (this.platform.is('android')) {
      window.open('market://details?id=com.vanshavali.app', '_system');
    } else {
      window.open(environment.apkUrl, '_blank');
    }
  }
}
